import { SERVICES_CONTANTS } from "@/modules/Services/constants/ServicesConstants";
import {
  OPERATORS_FILTERS,
  PANEL_INFO_CONSTANTS,
  STATE
} from "../../../shared/constants/GeneralConstants";
import {
  FILE_SIZE,
  IMG_TYPE,
  TYPES_ALLOWED
} from "@/shared/constants/GeneralConstants";
import { SecondaryFilter } from "../../Dashboards/AdminDashboard/models/SecondaryFilter";

export const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&#.$($)$_-])/;
export const NUMBER_PATTERN = "^[0-9]*$";

export const USER_STATES = {
  ACTIVE: "Activo",
  INACTIVE: "Inactivo"
};

export const USER_CONSTANTS = {
  ADD_PAGE_TITLE: "Agregar usuario",
  PAGE_EDIT_TITLE: "Editar usuario",
  EDIT_USER: "editar usuario",
  CREATE_USER: "agregar usuario",
  ADD_ROLE: "Agregar rol",
  ADD_ROLE_USER: "Crear rol",
  ADD_DEPENDENCY: "Agregar dependencia",
  ADD_USER_TEMPLATE: "Crear plantilla de usuario",
  SELECT_DEFAULT_TEMPLATE: "Plantilla Base",
  CREATE_INFORMATION_GROUP: "Crear grupo de información",
  USER_ROUTE: "/users",
  NAME_ROUTE: "User",
  CLEAN_SAVE_USER: "cleanSaveuser",
  EVENT_DATA_USER_ID: "getUserId",
  ROLE_SELECT: "rolSelect",
  DEPENDENCIES_SELECT: "dependenciesSelect",
  CAMPUS_SELECT: "campusSelect",
  DEFAULT_IMG:
    "https://firebasestorage.googleapis.com/v0/b/neumomeddesarrollo.appspot.com/o/Perfil-sin-foto.png?alt=media&amp;token=acf1ad0c-1ef6-47e6-a55b-83f24cec0b84",
  QUERY: {
    USER_ID: { NAME: "userIdProp" },
    USER_DOCUMENT: { NAME: "userDocumentProp" }
  },
  FIELD: {
    EMAIL: "Email principal",
    PHONE: "Teléfono de contacto",
    DOCUMENT: "Documento",
    FIRST_NAME: "Nombre1",
    SECOND_NAME: "Nombre2",
    SURNAME: "Apellido1",
    SECOND_SURNAME: "Apellido2",
    DOCUMENT_TYPE: "TipoDoc"
  },
  PAGE_USER_TITLE_SEARCH: "Consulta de usuarios",
  PAGE_TITLE: "Usuarios",
  BUTTON: {
    ADD_USER_TEXT: "Crear usuario",
    GROUP_BTN_TEXT: "Agregar grupos",
    UPDATE_SCHEMA_GROUPS: "Actualizar",
    ADD_GROUPS: "Agregar",
    VIEW: "Ver",
    EDIT: "Editar",
    DELETE: "Eliminar"
  },
  LABEL: {
    USER_NAME: "Usuario*",
    USER_PASSWORD: "Contraseña*",
    USER_PASSWORD_CONFIRM: "Confirmar contraseña*",
    USER_NEW_PASSWORD: "Nueva contraseña*",
    USER_NEW_PASSWORD_CONFIRM: "Confirmar nueva contraseña*",
    HINT_TEMPLATE:
      "Escriba el nombre de la plantilla y presiona enter para buscar",
    SEARCH_TEMPLATE: "Búsqueda de plantillas",
    HINT_SEARCH_TEMPLATE: "Seleccione una plantilla de la lista",
    ADD_TEMPLATE: "Plantilla*",
    USER_ROL: "Roles*",
    USER_DEPENDENCY: "Dependencias*",
    USER_CAMPUS: "Campus",
    ADD_GROUP_TEXT: "Elección de grupos de información adicionales",
    ADD_GROUP: "Grupos de información",
    HINT_SEARCH_GROUP: "Seleccione grupos adicionales de la lista",
    STATUS: "Estado: ",
    PROFILE_IMG: "Seleccione una foto de perfil",
    HINT_PROFILE_IMG: "La imagen debe pesar menos de 2MB",
    FORMAT_INVALID: "El formato debe ser PNG O JPG",
    SAVE: "save",
    CLOSE: "close"
  },
  ICONS: {
    SHOW: "mdi-eye-outline",
    NO_SHOW: "mdi-eye-off-outline"
  },
  DIALOG_MESSAGE: {
    USER_NAME_EXIST: "Ya existe un usuario con este nombre de usuario",
    NOT_FOUND_ROLES: "No se encontraron roles",
    NOT_FOUND_GROUPS: "No se encontraron grupos de información",
    NOT_FOUND_TEMPLATES: "No se encontraron plantillas",
    NOT_FOUND_USERS: "No se encontraron usuarios",
    SAVE: "Se ha guardado de forma exitosa",
    UPDATE: "Se ha actualizado de forma exitosa",
    ERROR_SAVE_USER: "Ocurrió un error al guardar",
    ERROR_EDIT_ID_NOT_FOUND: "El usuario a editar no existe",
    TYPE_FIELD_ERROR: "El tipo de campo no existe",
    NOT_FOUND_FORM_TEMPS: "No se encontraron plantillas de formularios",
    ERROR_SAVE_USER_TRY_LATER: "Ha ocurrido un error, intente más tarde.",
    USER_COULD_NOT_BE_DELETED: "Este usuario no puede ser eliminado",
    NOT_FOUND_DATA: "No se encontraron resultados.",
    DATE_BIRTH_GREATER:
      "La fecha de nacimiento no puede ser mayor a la fecha actual"
  },
  OPTIONS_PANEL: [
    {
      value: PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_USER_TEMPLATE,
      srcImg: "search-options.png",
      name: "Crear Plantilla de Usuarios"
    },
    {
      value: PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_ROLE,
      srcImg: "search-roles.png",
      name: "Crear Roles"
    },
    {
      value: PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_DEPENDENCIES,
      srcImg: "search-roles.png",
      name: "Crear Dependencias"
    }
  ],
  USER_FILTERS: {
    MAIN: {
      mainFilterKey: "user",
      mainFilterName: "Todos",
      avatar: "mdi-animation",
      secondaryFilters: [] as SecondaryFilter[],
      initial: true,
      placeholder:
        "Escriba el nombre del usuario o utiliza los filtros para agrupar información"
    },
    SECONDARY: {
      NAME: {
        name: "Nombre",
        placeholder: "Nombre de Usuario",
        key: "name",
        avatar: "mdi-form-textbox",
        type: "secondaryFilter",
        default: true,
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: "unique"
      },
      TELEFONO: {
        name: "Teléfono",
        placeholder: "Telefono de Usuario",
        key: "userPhone",
        avatar: "mdi-phone",
        type: "secondaryFilter",
        default: true,
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: "input"
      },
      CORREO: {
        name: "Correo",
        placeholder: "Correo de Usuario",
        key: "userEmail",
        avatar: "mdi-email",
        type: "secondaryFilter",
        default: true,
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: "input"
      },
      DOCUMENTO: {
        name: "Documento",
        placeholder: "Documento de Usuario",
        key: "userDocument",
        avatar: "mdi-id-card",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: "input",
        options: [] as {
          key: string;
          name: string;
        }[]
      },
      STATUS: {
        name: "Estado",
        placeholder: "Estado de Usuario",
        key: "userState",
        avatar: "mdi-list-status",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: "list",
        options: [
          { name: "Activo", key: "Activo" },
          { name: "Inactivo", key: "Inactivo" }
        ]
      },
      ROLES: {
        name: "Roles",
        placeholder: "Roles de Usuario",
        key: "userRole",
        avatar: "mdi-form-textbox",
        type: "secondaryFilter",
        default: true,
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: "list",
        options: [] as {
          key: string;
          name: string;
        }[]
      },
      DEPENDENCIAS: {
        name: "Dependencias",
        placeholder: "Dependencias de Usuario",
        key: "dependency",
        avatar: "mdi-form-textbox",
        type: "secondaryFilter",
        default: true,
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: "list",
        options: [] as {
          key: string;
          name: string;
        }[]
      }
    }
  },
  DEFAULT_TEMPLATE: "Usuarios Nuevos",
  DEFAULT_ROLE: "Paciente",
  DEFAULT_DEPENDENCY: "Pacientes",
  URL_ROUTE: "/profile"
};

export const TYPE_DOC_INTEGER_FIELDS = ["CN", "CE", "CC", "PE", "RC", "TI"];

export const USER_PHOTO_FORMAT = `image${IMG_TYPE.png}, image${IMG_TYPE.jpg}`;

export const QUERY_STATE_ACTIVE = {
  state: STATE.ACTIVE
};

export const QUERY_STATE_ACTIVE_PATIENT = {
  state: STATE.ACTIVE,
  name: SERVICES_CONTANTS.NAME_ROLE_PATIENT
};

export const USER_MESSAGES = {
  EQUAL_PASSWORD: "Las contraseñas deben ser iguales",
  MIN_6_CHARACTERS: "Debe ingresar por lo menos 6 caracteres",
  MIN_8_CHARACTERS: "Debe ingresar por lo menos 8 caracteres",
  NO_SPACES: "No se permiten espacios en este campo",
  ONE_ROLE: "Debe elegir al menos un rol",
  ONE_DEPENDENCY: "Debe elegir al menos una dependencia",
  ONE_CAMPUS: "Debe elegir al menos un campus",
  INVALID_PASSWORD_FORMAT:
    "La contraseña debe contener por lo menos una letra mayúscula, un número y un caracter especial",
  NO_CAPS: "Debe incluir al menos una mayuscula",
  NO_SECUENCE:
    "No se permiten ingresar caracteres consecutivos Ej: 1234 o abcd",
  INFO: {
    NO_INFO_TO_SHOW: "No hay usuarios para mostrar",
    EMPTY_STATE_TEXT:
      "Ingresa una palabra en la barra de búsqueda para encontrar el usuario que necesitas"
  },
  USERS_REASON_MODAL: {
    TITLE: "Eliminar usuario",
    MESSAGE: "Ingrese la razón por la cual va a deshabilitar el usuario: "
  },
  DELETE_MODAL: {
    TITLE: "Eliminar",
    MESSAGE: "¿Está seguro que desea Eliminar?"
  },
  DISABLED_MODAL: {
    TITLE: "Deshabilitar",
    MESSAGE: "¿Está seguro que desea deshabilitar este usuario?"
  },
  ENABLE_MODAL: {
    TITLE: "Habilitar",
    MESSAGE: "¿Está seguro que desea habilitar este usuario?"
  }
};

function validateSecuenceChar(value: string) {
  if (value.length <= 3 || value == "") {
    return true;
  }
  const chars = value.split("");
  let count = 1;
  for (let i = 0; i < chars.length - 1; i++) {
    const charn = chars[i].charCodeAt(0);
    const charn1 = chars[i + 1].charCodeAt(0);
    count = charn + 1 != charn1 && charn != charn1 ? 1 : count + 1;
    if (count >= 4) {
      return false;
    }
  }
  return true;
}

export const USER_VALIDATORS = {
  MIN_6: (v: string) => v.trim().length >= 6 || USER_MESSAGES.MIN_6_CHARACTERS,
  MIN_8: (v: string) => v.trim().length >= 8 || USER_MESSAGES.MIN_8_CHARACTERS,
  NO_SPACES: (v: string) => v.indexOf(" ") <= 0 || USER_MESSAGES.NO_SPACES,
  PASSWORD_PATTERN: (v: string) =>
    v.length > 0
      ? PASSWORD_PATTERN.test(v) || USER_MESSAGES.INVALID_PASSWORD_FORMAT
      : true,
  MAX_FILE_SIZE: (v: File) =>
    !v || v.size < FILE_SIZE || USER_CONSTANTS.LABEL.HINT_PROFILE_IMG,
  FILE_FORMAT: (v: File) =>
    !v || TYPES_ALLOWED.includes(v.type) || USER_CONSTANTS.LABEL.FORMAT_INVALID,
  NO_SECUENCE: (value: string) =>
    validateSecuenceChar(value) || USER_MESSAGES.NO_SECUENCE,
  CONTAINS_CAP_LETTER: (value: string) =>
    (value && /[A-Z]{1}/.test(value)) || USER_MESSAGES.NO_CAPS
};

export const USER_ACCESS = {
  GET: "consultar usuarios",
  POST: "crear usuarios",
  PUT: "modificar usuarios",
  DELETE: "eliminar usuarios"
};

export const ERROR_CODES = {
  SAVEUSER_GET_GROUPS: "SAVEUSER_001",
  SAVEUSER_GET_ROLES: "SAVEUSER_002",
  SAVEUSER_GET_TEMPLATES: "SAVEUSER_003",
  SAVEUSER_GET_DEPENDENCIES: "SAVEUSER_004"
};
export const BIRTHDAY_FIELD_MODEL = {
  MODEL: "fz9J1lXEdt",
  INPUT_NAME: "allOf-0-fz9J1lXEdt",
  INPUT_LABEL: "input",
  SEPARATOR: "T",
  CLEAR_VALUE: ""
};
